var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94543 5.61066C6.9401 6.41866 7.31343 6.35733 9.18277 6.232L26.8028 5.17466C27.1761 5.17466 26.8654 4.80133 26.7414 4.74L23.8134 2.624C23.2534 2.18933 22.5054 1.69066 21.0734 1.81466L4.01343 3.06C3.3921 3.12133 3.26677 3.43333 3.51477 3.68133L5.94543 5.61066ZM7.00277 9.71733V28.256C7.00277 29.252 7.5001 29.6253 8.62143 29.5627L27.9854 28.4427C29.1068 28.3813 29.2321 27.696 29.2321 26.8867V8.472C29.2321 7.664 28.9214 7.228 28.2348 7.28933L7.99877 8.472C7.2521 8.53466 7.00277 8.90933 7.00277 9.71733ZM26.1188 10.7107C26.2428 11.2707 26.1188 11.8307 25.5588 11.8947L24.6254 12.0813V25.7667C23.8148 26.2027 23.0681 26.452 22.4454 26.452C21.4481 26.452 21.1988 26.14 20.4521 25.208L14.3494 15.6267V24.896L16.2801 25.3333C16.2801 25.3333 16.2801 26.4533 14.7228 26.4533L10.4268 26.7013C10.3028 26.4533 10.4268 25.8307 10.8628 25.7067L11.9828 25.396V13.1387L10.4294 13.0133C10.3041 12.4533 10.6161 11.6453 11.4868 11.5827L16.0948 11.272L22.4468 20.9773V12.3907L20.8268 12.2053C20.7028 11.52 21.2001 11.0227 21.8228 10.9613L26.1188 10.7107ZM2.58143 1.38L20.3281 0.0733307C22.5068 -0.113336 23.0681 0.010664 24.4374 1.00666L30.1028 4.988C31.0361 5.672 31.3481 5.85866 31.3481 6.60533V28.4427C31.3481 29.8107 30.8508 30.6213 29.1081 30.744L8.49743 31.9893C7.19077 32.052 6.56677 31.8653 5.88143 30.9933L1.70943 25.58C0.962766 24.584 0.6521 23.8387 0.6521 22.9667V3.556C0.6521 2.43733 1.15077 1.50266 2.58143 1.38Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotion);
export default __webpack_public_path__ + "static/media/icon_notion.6b5d0991269cde211fb796282769c148.svg";
export { ForwardRef as ReactComponent };